module.exports = __webpack_public_path__ + "img/ai_remove_logo.fdeac1ea.png";